import { Package } from 'lucide-react'
import type { InfraProduct } from '@/types/infrastructure'
import styles from './Infrastructure.module.css'

/** The selected product, shown wherever the wizard shows its header, so it is never out of sight. */
export function ProductChip({ product }: { product: InfraProduct | null }) {
  if (!product) return null
  return (
    <span className={styles.chip} data-testid="product-chip" aria-label={`Product: ${product.name}`}>
      <Package size={12} aria-hidden="true" />
      Product: <strong>{product.name}</strong>
    </span>
  )
}
